import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import BuildingPage from "../BuildingPage";
import WelcomePage from "../WelcomePage";

const FretesTransportadora = lazy(() => import("./frete/FretePage"));

const AgendamentosTransportadora = lazy(() =>
  import("./agendamento/AgendamentoPage")
);

const OrcamentosTransportadora = lazy(() => import("./orcamento/OrcamentoPage"));

const OfertasTransportadora = lazy(() => import("./oferta/OfertaPage"));

const AvaliacaoTransportadora = lazy(() => import("./avaliacao/AvaliacaoPage"));

const ColaboradorTransportadora = lazy(() =>
  import("./colaborador/ColaboradorPage")
);

const GruposAcessoTransportadora = lazy(() => import("./group/GroupPage"));

const PerfilTransportadora = lazy(() => import("./perfil/PerfilPage"));

const MeuPerfilTransportadora = lazy(() => import("./meuPerfil/MeuPerfilPage"));

const PatioTransportadora = lazy(() => import("./patio/PatioPage"));

const MotoristaTransportadora = lazy(() => import("./motorista/MotoristaPage"));

const TracaoPage = lazy(() => import("./tracao/TracaoPage"));

const CarroceriaPage = lazy(() => import("./carroceria/CarroceriaPage"));

const ProprietarioAnttPage = lazy(() =>
  import("./proprietario-antt/ProprietarioAnttPage")
);

const MinhasPlacasPage = lazy(() => import("./minhas-placas/MinhasPlacasPage"));

const FaturadosTransportadora = lazy(() => import("./faturados/FaturadosPage"));

const AgendamentoUsina = lazy(() => import("../usina/AgendamentoUsinaPage"));

const USUARIOS_COM_ACESSO_USINA = [
  990, 1760, 1793, 1038, 949, 1187, 1807, 1752, 1810, 1659, 1074, 1663, 1382,
  1483, 1067, 314, 1820, 968, 1735, 1862, 1736, 1867, 1269, 1860, 1569, 1890,
  1894, 1872, 1909, 1911, 1916, 1918, 1922, 1923, 1926, 1912, 1962, 1964, 1851,
  1980, 1989, 1990, 1988, 2011, 2012, 1838, 2010, 2017, 2018, 2019, 2015, 1808,
  2014, 2016, 2021, 2024, 2020, 2025, 2022, 2026, 1837, 2027, 2031, 2032, 2036,
  2034, 2048, 2082, 2085, 2236, 2252,
];

export default function TransportadorRoutes({ user }) {
  const displayUsina = USUARIOS_COM_ACESSO_USINA.includes(user?.id);

  return (
    <Switch>
      <Route exact path="/" component={WelcomePage} />

      <Route path="/transportador/dashboard" component={BuildingPage} />
      <Route path="/transportador/frete" component={FretesTransportadora} />
      <Route path="/transportador/agendamento" component={AgendamentosTransportadora} />
      <Route path="/transportador/leilao" component={BuildingPage} />
      <Route path="/transportador/orcamento" component={OrcamentosTransportadora} />
      <Route path="/transportador/oferta" component={OfertasTransportadora} />
      <Route path="/transportador/colaborador" component={ColaboradorTransportadora} />
      <Route path="/transportador/grupos-acesso" component={GruposAcessoTransportadora} />
      <Route path="/transportador/avaliacao" component={AvaliacaoTransportadora} />
      <Route path="/transportador/relatorio" component={BuildingPage} />
      <Route path="/transportador/minha-empresa" component={PerfilTransportadora} />
      <Route path="/transportador/meu-perfil" component={MeuPerfilTransportadora} />
      <Route path="/transportador/patio" component={PatioTransportadora} />
      <Route path="/transportador/motorista" component={MotoristaTransportadora} />
      <Route path="/transportador/tracao" component={TracaoPage} />
      <Route path="/transportador/carroceria" component={CarroceriaPage} />
      <Route path="/transportador/minhas-placas" component={MinhasPlacasPage} />
      <Route path="/transportador/proprietario-antt" component={ProprietarioAnttPage} />
      <Route path="/transportador/faturados" component={FaturadosTransportadora} />
      {displayUsina && (
        <Route path="/transportador/usina" component={AgendamentoUsina} />
      )}
    </Switch>
  );
}
